import React from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { requestFields, formatSitesList } from "helpers/ManufSiteHelper";
import { setValue } from "actions/request";
import { clearCurrSite } from "actions/sitesSar";

class SiteSelector extends React.Component {
  requestField = requestFields.siteId;

  componentDidUpdate(prevProps) {
    const optionPrev = Number(prevProps.request[requestFields.siteOption]);
    const optionCurr = Number(this.props.request[requestFields.siteOption]);

    if (optionPrev > 0 && optionCurr > 0) {
      if (optionPrev !== optionCurr) {
        this.props.setValue(this.requestField, 0);
        this.props.clearCurrSite();
      }
    }
  }

  onChange = event => {
    const { setValue } = this.props;
    const siteId = event.target.value;

    // set siteAddress value
    setValue(this.requestField, siteId);
  };

  setShowOption = () => {
    const { request, sites } = this.props;
    if (!request || !sites) return false;

    const { list } = sites;
    if (!list || !list.length) return false;

    if (Number(request[requestFields.siteOption]) !== 1) return false;

    return true;
  };

  setFieldValue = () => {
    const { request } = this.props;
    const activeOption = Number(request[requestFields.siteOption]);

    if (activeOption === 1) {
      return request[this.requestField] || 0;
    }

    return 0;
  };

  setListValue = () => {
    const list = [];
    const { sites } = this.props;

    if (!sites) return list;
    if (!sites.list || !sites.list.length) return list;

    return sites.list;
  };

  setRenderOptions = () => {
    return {
      show: this.setShowOption(),
      fieldValue: this.setFieldValue(),
      list: this.setListValue()
    };
  };

  render() {
    const { show, fieldValue, list } = this.setRenderOptions();

    if (!show) return null;

    return (
      <FormElement
        type="select"
        id={this.requestField}
        show={true}
        value={fieldValue}
        onChange={this.onChange}
        options={formatSitesList(list)}
      />
    );
  }
}

function mapStateToProps({ request, sites }) {
  return { request, sites };
}

export default connect(mapStateToProps, {
  setValue,
  clearCurrSite
})(SiteSelector);
